<template>
    <ion-header>
        <ion-toolbar>
            <ion-buttons slot="start">
                <ion-back-button></ion-back-button>
            </ion-buttons>
            <ion-title>{{ trap.device_type }}</ion-title>
            <ion-buttons slot="end">
                <ion-button @click="confirm" :strong="true">Confirm</ion-button>
            </ion-buttons>
        </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding" style="--background: var(--ion-item-background)">
        <ion-header collapse="condense">
            <ion-toolbar style="--background: var(--ion-item-background)">
                <ion-title slot="start" class="w-full text-left" style="padding-inline: 0"><h1 class=" font-bold">
                    Fornisci i dettagli</h1></ion-title>
            </ion-toolbar>
        </ion-header>
        <form class="">
            <ion-input class="mei-input mei-note-input ion-margin-top"
                       v-model="label" label="Etichetta"
                       label-placement="stacked"></ion-input>
            <ion-input class="mei-input mei-note-input ion-margin-top"
                       v-model="area" label="Area"
                       label-placement="stacked"></ion-input>
        </form>
    </ion-content>
</template>

<script setup lang="ts">
import {
    IonBackButton,
    IonButton,
    IonButtons,
    IonContent,
    IonHeader, IonInput,
    IonTitle, IonToolbar, modalController
} from "@ionic/vue";
import {inject, PropType, ref} from "vue";
import {ITrap} from "@/types/trap";
import {IInspection} from "@/types/inspection";
import {
    generateAudit,
    IAudit,
    IIndoorFloorTrapAudit,
    IIndoorFlyingTrapAudit,
    IOutdoorTrapAudit
} from "@/types/audit";

const props = defineProps({
    trap: {
        type: Object as PropType<ITrap>,
        required: true,
    }
});

const area = ref<string>('');
const label = ref<string>('');
const inspection: IInspection | undefined = inject('inspection');

const cancel = () => {
    return modalController.dismiss(null, 'cancel');
}
const confirm = () => {
    let audit: IOutdoorTrapAudit | IIndoorFloorTrapAudit | IIndoorFlyingTrapAudit | undefined;
    if (inspection) {
        audit = generateAudit(props.trap, area.value, label.value, inspection!.id)
    }
    return modalController.dismiss(audit, 'confirm');
}
</script>

<style scoped>

</style>
